import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import Order from '../../models/Order';
import OrderProduct from '../../models/Order';
import ArrayList from '../../models/ArrayList';
import {Observable} from "rxjs/Observable";
import {catchError, filter, map, mergeMap, take, tap, timeout} from "rxjs/operators";
import {PreloaderService} from "../../common/services/preloader/preloader.service";
import * as _ from 'lodash';
import ActivityLog from "../../models/ActivityLog";
import TemporaryPrice from "../../models/TemporaryPrice";
@Injectable()
export class OrderService extends ServiceProvider {

  protected url = '/api/v1/orders';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      'Order'
    );
  }
  getOrderByOrderId(order_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/order_id/' + order_id).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new Order((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  downloadInvoice(order_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/order_id/' + order_id + '/invoice').pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  downloadInvoices(data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/invoices', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        result
      ),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  regenerateInvoice(order_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/order_id/' + order_id + '/invoice?regenerate=true').pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  prepareOrderProductsShipment(order_id, product_id, data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.put(this.apiUrl.getApiUrl(this.url) + '/' + order_id + '/product/'  + product_id + '/prepare', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => new OrderProduct((result as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  cancelOrderProducts(order_id, product_id, data?:{}): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + order_id + '/product/'  + product_id + '/cancel', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  updateTrackingNumber(order_id, product_id, data?: {}): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(`${this.url}/${order_id}/product/${product_id}/update-tracking-number`), data).pipe(
      tap((result) => {}),
      map((result: any) => _.map(result.data, (item) => new Order(item))),
      catchError((error) => {
        throw error;
      })
    );
  }

  sellerConfirmShipping(order_id, product_id, data?: {}): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + order_id + '/product/'  + product_id + '/confirm-shipped', data).pipe(
      tap(result => {
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  sendToAccountingTool(order_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + order_id + '/export/xero', {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  populateOrder(): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/populate-confirm' , {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getLogs(id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/' + id + '/logs').pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(results => new ArrayList<ActivityLog>(ActivityLog, (results as any).data)),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  setOrderAsPrinted(order_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + order_id + '/printed', {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
}
